import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import React, { FC } from "react";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface IStatusDialogProps {
	open: boolean;
	message: string;
	type: "error" | "success";
	onClose: () => void;
}

const StatusDialog: FC<IStatusDialogProps> = (props) => {
	const { open, message, type, onClose } = props;

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
			<DialogContent>
				<Box
					sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}
				>
					{type === "error" ? (
						<ErrorIcon color="error" sx={{ fontSize: "48px" }} />
					) : type === "success" ? (
						<CheckCircleIcon color="success" sx={{ fontSize: "48px" }} />
					) : null}

					<Typography variant="h6" textAlign="center">
						{message}
					</Typography>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default StatusDialog;
